import { render, staticRenderFns } from "./Pix.vue?vue&type=template&id=38b726c0&"
import script from "./Pix.vue?vue&type=script&lang=ts&"
export * from "./Pix.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports